<template>
  <div>
    <tree-view :tree="treeData" v-on:operate="operate"></tree-view>
  </div>
</template>

<script>
  import TreeView from '@/components/utils/tree-view'
  import { UploaddataManager } from '@/components/home/controllers/upload-data'

  export default {
    created () {
      this._imported = () => this.updateTreeData()
      this._uploadMetadata = () => this.updateTreeData()

      this.$emitter.on('imported', this._imported)
      this.$emitter.on('updateMetadata', this._uploadMetadata)
      this.metadataManager = new UploaddataManager(this)
      this.updateTreeData()

      this.metadataManager.afterSubmitHook = () => {
        this.updateTreeData()
      }
    },
    destroyed () {
      this.$emitter.removeListener('imported', this._imported)
      this.$emitter.removeListener('updateMetadata', this._uploadMetadata)
    },
    data () {
      return {
        treeData: []
      }
    },
    components: {
      TreeView
    },
    methods: {
      async operate (operation, data) {
        await this.metadataManager.processOperation(operation, data)
        this.updateTreeData()
      },
      async updateTreeData () {
        this.treeData = await this.metadataManager.genTreeData()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/trees/uploaddata-tree.vue